import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalSettingsService} from '../../services/ui/global-settings.service';
import {JobProcedureFormBypassRequestDetails} from '../../models/jobProcedureFormBypassRequestDetails';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import {fadeIn, fadeOut, slideDown, slideUp} from '../../animations';
import {JobProcedureService} from '../../services/sections/job/job-procedure.service';
import {CompleteRequest} from '../../models/completeRequest';
import {GenericModalComponent} from '../generic-modal/generic-modal.component';

@Component({
  selector: 'procedure-form-bypass',
  templateUrl: './procedure-form-bypass.component.html',
  styleUrls: ['./procedure-form-bypass.component.scss', '../job-details/job-details.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss'],
  animations: [slideUp(100), slideDown(100), fadeIn(200), fadeOut(200)]
})
export class ProcedureFormBypassComponent implements AfterViewInit {

  @ViewChild('procedureFormBypassResponseModal') public procedureFormBypassResponseModal: GenericModalComponent;
  @ViewChild('procedureFormBypassResponseModalError') public procedureFormBypassResponseModalError: GenericModalComponent;

  public isLoading = false;
  public self = this;
  public jobProcedureFormBypassRequestDetails: JobProcedureFormBypassRequestDetails;
  public readonly ButtonIcons = ButtonIcons;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private jobProcedureService: JobProcedureService
  ) {
    this.jobProcedureFormBypassRequestDetails = this.route.snapshot.data.procedureFormBypassDetails as JobProcedureFormBypassRequestDetails;
  }

  get formattedFormName(): string {
    const {listOrder, formName} = this.jobProcedureFormBypassRequestDetails.requestDetails || {};
    return listOrder && formName ? `[Step ${listOrder}] ${formName}` : '';
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;
  }

  public navigateWithData(subpage: string): void {
    this.router.navigate([subpage], { relativeTo: this.route, state: { jobProcedureFormBypassRequestDetails: this.jobProcedureFormBypassRequestDetails } });
  }

  public submitApprove(): void{
    this.isLoading = true;

    const updateRequestModel: CompleteRequest  = {
        isApproved: true,
        comment : null
    };

    this.jobProcedureService.updateJobProcedureFormBypassRequest(this.route.snapshot.paramMap.get('token'), updateRequestModel)
        .subscribe(
        () => {
            GlobalSettingsService.isSecondaryLoaderLoading = false;
            this.procedureFormBypassResponseModal.open();
            this.isLoading = false;
        },
        () => {
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          this.procedureFormBypassResponseModalError.open();
        });
  }

  public closeProcedureFormBypassResponseModal(){
    this.procedureFormBypassResponseModal.hide();

    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

}
